import { useNavigate } from 'react-router-dom';

import { useEffect, useState } from 'react';
import { getCatSubCat, getUserDashboard } from '../../api';

import { CategoryCard, CurrentRedemPoint, goToLink, loginLogout, SpecialFiltter, useProjectByStorage, WarningDisplay } from '../../projectData';
import { useRouteData } from '../../RouteDataContext';
import { FullPageLoader } from '../../../component/helper';


/**
 * RedemptionCategory component displays available redemption categories for the user.
 * Handles dashboard data, category fetch, and navigation to sub-categories.
 */
const RedemptionCategory = () => {
    const navigate = useNavigate();
    const { userData } = useRouteData();
    const [loader, setLoader] = useState(false);
    const project = useProjectByStorage();
    const [dashboard, setDashboard] = useState(null);
    const [categoryitems, setCategoryItems] = useState([]);



    useEffect(() => {
        setLoader(true);
        if (userData && project) {
            getUserDashboard({ id: userData?.user?.iirpl_sap_code, project_key: project?.pkey }).then((d) => { setDashboard(d?.data) })
            getCatSubCat({ project_key: project?.pkey })
                .then((d) => {
                    setCategoryItems(d?.data)
                    setTimeout(() => {
                        setLoader(false);
                    }, 500)

                })
                .catch((error) => {
                    loginLogout(error.response)
                })
        }


    }, [userData, project])



    return (
        <div className='container pt-5 bg-white vh-100'>
            <CurrentRedemPoint dashboard={dashboard} />
            <div className="mb-4">
                <div className='text-center mt-6 fw-semibolder text-dark fs-3'>Please Select Category</div>
                <div className="row mt-6">
                    <SpecialFiltter />
                    {Array.isArray(categoryitems) && categoryitems.length > 0 ? (categoryitems.map((item, index) => (
                        <>
                            <div onClick={() => goToLink(navigate, `/customer/redem-sub-category/${item?.ID}`, { itemValue: item, dashboard: dashboard })} className="col-6 mb-4" key={item?.ID}>
                                <CategoryCard item={item} />
                            </div>
                        </>
                    ))) : <>{!loader && <WarningDisplay message={'Not Found'} />}</>
                    }

                </div>
            </div>

            {loader &&
                <FullPageLoader />
            }
        </div>
    )
}

export default RedemptionCategory